/*
 * @Author: Teemo Ding
 * @Date: 2022-04-15 16:36:07
 * @LastEditTime: 2022-08-19 13:07:52
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Analytics/Reports/ReportsList/config.tsx
 */
import { replaceI18nVariables } from '@/src/tools/tools';
import React from 'react';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import {
  fulfillmentStatusesText,
  paymentStatusText,
  statusText,
} from 'src/pages/Order/config';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { handleOnFormatStoreTimeAndDateWithTimezone } from '@/src/tools/tools';
import { EnumTablePosition } from 'src/types/common/common';
import { ICategory } from 'src/types/common/report';
import css from './css.module.less';

export {
  breadcrumbData,
  columns,
  fulfillmentStatusesText,
  paymentStatusText,
  statusText,
  tabsConfig,
};

const tabsConfig = ({ getI18n }) => [
  //定义tabs列表
  { name: getI18n('general.all'), key: ICategory.Null },
  {
    name: getI18n('reports.reportConfig.namedict1.order'),
    key: ICategory.Order,
  },
  { name: getI18n('general.subscriptionBuy'), key: ICategory.SubscriptionBuy },
  {
    name: getI18n('reports.reportConfig.namedict1.Payment'),
    key: ICategory.Payment,
  },
  {
    name: getI18n('reports.reportConfig.namedict1.Promotion'),
    key: ICategory.Promotion,
  },
  {
    name: getI18n('reports.reportConfig.namedict1.Parcel'),
    key: ICategory.Parcel,
  },
  {
    name: getI18n('reports.reportConfig.namedict1.Customer'),
    key: ICategory.Customer,
  },
  { name: getI18n('reports.reportlist.product'), key: ICategory.Product },
  { name: getI18n('general.sider.inventory'), key: ICategory.Inventory },
  { name: getI18n('reports.reportlist.page'), key: ICategory.Page },
  {
    name: getI18n('reports.reportConfig.namedict1.G&C'),
    key: ICategory.GiftCard,
  },
  {
    name: getI18n('reports.reportConfig.namedict1.orderlineitem'),
    key: ICategory.OrderLineItemsReport,
  },
];

const breadcrumbData = ({ getI18n }) => [
  {
    url: '',
    name: getI18n('general.sider.home'),
  },
  {
    url: '',
    name: getI18n('reports.reportingDashboardcommon.config.Analytics'),
  },
  {
    url: '',
    name: getI18n('reports.reportdetailcommon.reports'),
  },
];

const columns = (
  timezoneInGMT,
  onDelete,
  onEdit,
  disableEdit,
  disableDelete,
  { getI18n },
) => [
  {
    title: getI18n('reports.reportpagecommon.reportName'),
    dataIndex: 'name',
    key: 'name',
    default: true,
    optional: false,
    sorter: true,
    className: css.columnClass,
    width: 360,
  },
  {
    title: getI18n('reports.reportpagecommon.reportCategory'),
    dataIndex: 'category',
    default: true,
    optional: false,
    key: 'category',
    className: css.columnClass,
    minWidth: 240,
  },
  {
    title: replaceI18nVariables(
      getI18n('reports.reportlist.lastModifiedDate(GMT${timezoneInGMT})'),
      timezoneInGMT,
    ),
    dataIndex: 'modifiedDate',
    default: true,
    optional: false,
    sorter: true,
    key: 'modifiedDate',
    className: css.columnClass,
    minWidth: 240,
    childGenerate: (text, record) => (
      <NoWrapContainer>
        <GlobalTooltip title={handleOnFormatStoreTimeAndDateWithTimezone(text)}>
          {handleOnFormatStoreTimeAndDateWithTimezone(text)}
        </GlobalTooltip>
      </NoWrapContainer>
    ),
  },
  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'action',
    default: true,
    optional: false,
    key: 'action',
    className: css.columnClass,
    position: EnumTablePosition.mid,
    align: 'center',
    minWidth: 208,
    childGenerate: (text, record) => (
      <Actions
        onDelete={() => onDelete([record.uuid])}
        onEdit={() => onEdit(record.category, record.uuid)}
        disableDelete={disableDelete}
        disableEdit={disableEdit}
      />
    ),
  },
];
